<template>
	<div class="gift-body">
		<div style="width:100%;flex:1;display:flex;flex-direction: column;overflow-y:auto">
			<div class="order-menu">
				<span>
					<i class="el-icon-back" @click="goBack"></i>
				</span>{{isAdd ? '新增卡型' : '编辑卡型'}}
			</div>
			<div class="fx-title">
				<span>卡型基础信息</span>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					会员卡名称：
				</div>
				<div class="gift-row-content" style="flex:1;display:flex;align-items: center;justify-content: space-between;">
					<el-input style="width:200px" v-model="name" maxlength="10" :disabled="isDisable" size="mini" placeholder="不超过10字"></el-input>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					促销方式：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable" v-model="discountrule" :label="0">折扣</el-radio>
					<el-radio :disabled="isDisable" v-model="discountrule" :label="1">立减</el-radio>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					促销条件：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable" v-model="discountcondition" :label="0">无门槛</el-radio>
					<el-radio :disabled="isDisable" v-model="discountcondition" :label="1">满金额</el-radio>
					<el-input v-if="discountcondition === 1" size="mini" :disabled="isDisable" placeholder="请输入内容" @blur="needmoneyBlur" @input="needmoneyCheck" v-model="needmoney">
						<template slot="append">元</template>
					</el-input>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					促销内容：
				</div>
				<div class="gift-row-content">
					<div style="min-width:40px">
						{{discountrule !== 1 ? '折扣' : '立减'}}
					</div>
					<el-input v-if="discountrule === 0" size="mini" :disabled="isDisable" placeholder="请输入内容" v-model="salecount" @blur="salecountBlur" @input="salecountCheck">
						<template slot="append">折</template>
					</el-input>
					<el-input v-if="discountrule === 1" size="mini" :disabled="isDisable" placeholder="请输入内容" v-model="discountmoney" @blur="discountmoneyBlur" @input="discountmoneyCheck">
						<template slot="append">元</template>
					</el-input>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					有效期：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable" v-model="discountDateType" :label="0">永久</el-radio>
					<el-radio :disabled="isDisable" v-model="discountDateType" :label="1">规定时间</el-radio>
					<el-date-picker
						v-if="discountDateType === 1"
						:disabled="isDisable"
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						class="time-input"
						size="mini"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm:ss'
						value-format='yyyy-MM-dd HH:mm:ss'>
					</el-date-picker>
				</div>
			</div>
			<div class="fx-title">
				<span>券限制信息</span>
			</div>
			<div>
				<div class="gift-row">
					<div class="gift-row-title">
						<span style="color:#EE4F31">*</span>
						活动叠加：
					</div>
					<div class="gift-row-content" style="width:400px">
						<el-radio :disabled="isDisable" v-model="addupflag" :label="0">不可叠加使用</el-radio>
						<el-radio :disabled="isDisable" v-model="addupflag" :label="1">可叠加使用</el-radio>
					</div>
					<div style="color:red">注：如可叠加使用则用户下单时先进行活动和优惠券计算，再进行会员卡优惠计算！</div>
				</div>
				<div style="display: flex;align-items: center;height: 40px;">
					<div style="width:130px;text-align: right;font-size: 13px;">
						<span style="color:#EE4F31">*</span>适用店铺：
					</div>
					<el-radio style="min-height: 40px;;line-height: 40px;" :disabled="isDisable" v-model="shopattendway" :label="0">全部店铺</el-radio>
					<el-radio style="min-height: 40px;;line-height: 40px;" :disabled="isDisable" v-model="shopattendway" :label="1">部分店铺</el-radio>
					<div  v-if="shopattendway === 1 && !isDisable" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
						<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
						选择店铺
					</div>
				</div>
				<div v-if="shopattendway === 1" style="display: flex;">
					<div style="width:130px;text-align: right;line-height: 30px;font-size: 13px;">
						已选：
					</div>
					<div style="display:flex;align-items: center;line-height:30px;text-align: left;">{{shopText}}</div>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					适用商品：
				</div>
				<div class="gift-row-content" style="width:400px">
					<el-radio :disabled="isDisable" v-model="productattendway" :label="0">全部商品可用</el-radio>
					<el-radio :disabled="isDisable" v-model="productattendway" :label="1">指定分类可用</el-radio>
				</div>
			</div>
			<div v-if="productattendway === 1" style="width:100%;padding-left:130px;box-sizing: border-box;">
				<el-checkbox-group v-model="checkList" style="display:flex;flex-wrap: wrap;">
					<el-checkbox style="margin:5px" v-for="(item,index) in categoryList" :disabled="isDisable" :key='index' :label="item.id">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					适用会员等级：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable" v-model="customerlevelattendway" :label="0">全部会员等级</el-radio>
					<el-radio :disabled="isDisable" v-model="customerlevelattendway" :label="1">指定会员等级</el-radio>
					<div style="color:red">注意：如等级下的客户已有其它会员卡型，保存后会进行覆盖，以保证每个等级的客户仅拥有一种会员卡型</div>
				</div>
			</div>
			<div v-if="customerlevelattendway === 1">
				<el-checkbox-group v-model="customerLevelIds" class="level-box">
					<el-checkbox border class="level-item" v-for="(item,index) in levelList" :disabled="isDisable" :key='index' :label="item.customerlevelid">
						<div>{{item.customerlevelname}}</div>
						<div>客户数：{{item.customercount}}</div>
						<div>其他卡型：{{item.discountid === '0' ? '未绑定' : '已绑定'}}</div>
					</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<div style="height:60px;line-height:60px;width:100%;text-align:center">
			<el-button size="mini" v-if="!isDisable" @click='goBack'>取消</el-button>
			<el-button size="mini" v-if="!isDisable" type="primary" @click='saveClick'>保存</el-button>
		</div>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'vipDetail',
	components: {
		bindShop
	},
	data () {
		return {
			id: '',
			discountcondition: 0,
			needmoney: '0',
			discountrule: 0,
			salecount: '0',
			discountmoney: '0',
			addupflag: 0,
			levelList: [],
			customerlevelattendway: 1,
			discountDateType: 0,
			dateValue: [],
			isAdd: true,
			name: '',
			useconditionflag: 0,
			productattendway: 0,
			shopattendway: 0,
			shopText: '',
			isDisable: true,
			chooseShop: [],
			checkList: [],
			customerLevelIds: [],
			shopDialog: false,
			categoryList: [],
			AuthorityList: {
				'08_0005_0001_00': false,
				'08_0005_0002_00': false,
				'08_0005_0003_00': false,
				'08_0005_0004_00': false
			},
			code: ''
		}
	},
	created () {
		this.getCategoryList()
		this.getLevelList()
		let id = window.sessionStorage.getItem('vipId')
		if (id) {
			this.id = id
			this.getDetail()
			this.isAdd = false
		} else {
			this.isAdd = true
		}
		this.getAuthority('08_0005_0000_00')
	},
	methods: {
		discountmoneyCheck () {
			this.discountmoney = this.discountmoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.discountmoney = this.discountmoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.discountmoney = this.discountmoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.discountmoney = this.discountmoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		},
		discountmoneyBlur () {
			if (this.discountmoney === '') {
				this.discountmoney = 0.00
			} else {
				if (+this.discountmoney > 1000000) {
					this.discountmoney = 999999.99
				}
				this.discountmoney = this.$fxUtils.toFixedSHW(this.discountmoney, 2)
			}
		},
		salecountCheck () {
			this.salecount = this.salecount.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.salecount = this.salecount.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.salecount = this.salecount.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.salecount = this.salecount.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		},
		salecountBlur () {
			if (this.salecount === '') {
				this.salecount = 0.00
			} else {
				if (+this.salecount > 10) {
					this.salecount = 10
				}
				this.salecount = this.$fxUtils.toFixedSHW(this.salecount, 2)
			}
		},
		needmoneyCheck () {
			this.needmoney = this.needmoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.needmoney = this.needmoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.needmoney = this.needmoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.needmoney = this.needmoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		},
		needmoneyBlur () {
			if (this.needmoney === '') {
				this.needmoney = 0.00
			} else {
				if (+this.needmoney > 1000000) {
					this.needmoney = 999999.99
				}
				this.needmoney = this.$fxUtils.toFixedSHW(this.needmoney, 2)
			}
		},
		getDetail () {
			let params = {
				id: this.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/getdetail4card`,
				data: params
			}).then(res => {
				if (!res.result) {
					this.$message.error(res.msg)
					return false
				} else {
					let data = res.data
					let discount = res.data.discount
					let card = res.data.card
					this.name = discount.name
					this.code = discount.code
					this.discountDateType = discount.discountDateType
					if (this.discountDateType === 1) {
						this.dateValue = [discount.begindate, discount.enddate]
					}
					this.discountcondition = card.discountcondition
					this.discountrule = card.discountrule
					this.needmoney = card.needmoney
					this.salecount = card.salecount
					this.discountmoney = card.discountmoney
					this.addupflag = card.addupflag
					this.shopattendway = discount.shopattendway
					this.productattendway = card.productattendway
					this.customerlevelattendway = card.customerlevelattendway
					this.initShopData(data.shops)
					if (this.customerlevelattendway === 1) {
						this.customerLevelIds = data.customerlevels.map(item => {
							return item.levelid
						})
					}
					if (this.productattendway === 1) {
						this.checkList = data.productList.map(item => {
							return item.categoryid
						})
					}
				}
			})
		},
		initShopData (data) {
			let textArr = []
			let ids = []
			data.forEach(item => {
				ids.push(item.shopid)
				textArr.push(item.shopname)
			})
			this.shopText = textArr.join('，')
			this.chooseShop = ids
		},
		getLevelList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/card/customerlevel`
			}).then(res => {
				this.levelList = res.data
			})
		},
		goBack () {
			this.$fxEventBus.$emit('setMenu', '9-5')
			this.$router.push('vipList')
		},
		checkSave () {
			if (this.name === '') {
				this.$message.error('请填写会员卡名称')
				return false
			}
			if (this.discountcondition === 1 && this.needmoney === '') {
				this.$message.error('请填写促销条件')
				return false
			}
			if (this.discountrule === 0 && this.salecount === '') {
				this.$message.error('请填写促销内容')
				return false
			}
			if (this.discountrule === 1 && this.discountmoney === '') {
				this.$message.error('请填写促销内容')
				return false
			}
			if (this.discountDateType === 1 && this.dateValue.length === 0) {
				this.$message.error('请选择有效期')
				return false
			}
			if (this.shopattendway === 1 && this.chooseShop.length === 0) {
				this.$message.error('请选择适用店铺')
				return false
			}
			if (this.productattendway === 1 && this.checkList.length === 0) {
				this.$message.error('请选择适用商品')
				return false
			}
			if (this.customerlevelattendway === 1 && this.customerLevelIds.length === 0) {
				this.$message.error('请选择适用会员等级')
				return false
			}
			return true
		},
		saveClick () {
			if (!this.checkSave()) {
				return false
			}
			let arr = []
			this.checkList.forEach(item => {
				arr.push({ categoryid: item })
			})
			let params = {
				id: this.id,
				name: this.name,
				discountDateType: this.discountDateType,
				beginDate: this.dateValue[0],
				endDate: this.dateValue[1],
				discountcondition: this.discountcondition,
				needmoney: this.needmoney,
				discountrule: this.discountrule,
				salecount: this.salecount,
				discountmoney: this.discountmoney,
				addupflag: this.addupflag,
				shopattendway: this.shopattendway,
				productattendway: this.productattendway,
				customerlevelattendway: this.customerlevelattendway,
				customerLevelIds: this.customerLevelIds,
				shopIds: this.chooseShop,
				detail: arr,
				code: this.code
			}

			let logger = null
			let id = window.sessionStorage.getItem('vipId')
			if (id) {
				logger = this.$fxLogger.createInfo('discount.vip_info.update', { name: params.name, code: this.code })
			} else {
				logger = this.$fxLogger.createInfo('discount.vip_info.add', { name: params.name })
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/saveorupdate4card`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.id = res.data
					window.sessionStorage.setItem('vipId', res.data)
					this.getLevelList()
					this.getDetail()
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getCategoryList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/baseCategory/getShopCategories4Gift`
			}).then(res => {
				this.categoryList = res.data
			})
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		bindShopClick () {
			this.shopDialog = true
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					if (this.isAdd && this.AuthorityList['08_0005_0003_00']) {
						this.isDisable = false
					}
					if (!this.isAdd && this.AuthorityList['08_0005_0004_00']) {
						this.isDisable = false
					}
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.level-box{
	width:100%;
	padding-left:130px;
	box-sizing: border-box;
	display:flex;
	flex-wrap: wrap
}
.level-item{
	text-align: left;
	min-width: 300px;
	height: 80px;
	margin-left:0 !important;
	margin-bottom: 10px;
	display: flex;
}
.li-top {
  width: 350px;
  height: 87px;
  position: relative;
  display: flex;
}
.li-top .head-img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.li-left {
  width: 210px;
  font-size: 10px;
  padding: 10px;
  padding-left: 15px;
  z-index: 10;
  box-sizing: border-box;
  flex-direction: column;
  display: flex;
  justify-content: space-around;
}
.left-title {
  font-size: 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
}
.li-left .left-cion {
  display: inline-block;
  width: 40px;
  height: 17px;
  text-align: center;
  line-height: 17px;
  background: #E86C57;
  border-radius: 15px;
  font-size: 10px;
  color: #fff;
  font-weight: normal;
  margin-right: 8px;
}
.li-left .arrow-icon {
  width: 8px;
  height: 8px;
  margin-left: 5px;
}
.left-shop {
  color: #666;
  display: flex;
  align-items: center;
}
.li-right {
  width: 140px;
  font-size:12px;
  padding: 7px;
  box-sizing: border-box;
  flex-direction: column;
  display: flex;
  justify-content: space-around;
  position: relative;
  color: #fff;
  align-items: center;
}
.li-right .right-num {
  position: absolute;
  top: 5px;
  right: 3px;
  font-weight: bold;
  color: #333;
  font-size: 10px;
}
.li-right .right-use {
  width: 65px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background: #FCE4B9;
  border-radius: 15px;
  font-size: 11px;
  color: #BF4B47;
  font-weight: bold;
}
.li-des {
  width: 350px;
  background-color:#FFF0D7;
  padding: 12px 10px;
  box-sizing: border-box;
  color: #595959;
  font-size: 10px;
}
.gift-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow :hidden;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.order-menu {
		height: 50px
		line-height: 50px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
		span {
			display: inline-block;
			line-height: 50px;
			padding-right: 10px;
			i {
				border-radius: 50%;
				background: #9da6af;
				padding: 3px;
				cursor: pointer;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.gift-row{
		min-height :40px;
		display :flex;
		flex-direction :row;
		align-items :center;
		.gift-row-title{
			width :130px;
			height :40px;
			display :flex;
			align-items :center;
			font-size :13px;
			justify-content: flex-end;
		}
		.gift-row-content{
			height:40px;
			display :flex;
			align-items :center;
			text-align :left
		}
		.condition-des {
			color:#EE4F31;
			text-align:left;
			margin-bottom: 5px
		}
	}
	.main-product-box{
		text-align: left;
	}
	.product-name-box{
		display:inline-block;
		background-color:#eceffc;
		padding:0px 10px;
		line-height:30px;
		margin-left:10px;
		border-radius: 4px;
	}
	.filters-container {
		display: flex;
		flex-direction: row;
		height: 50px;
		align-items: center;
		margin-bottom:10px;
		.input-box{
			margin-right:10px
		}
		.el-input {
			width: 200px
		}
	}
	.point{
		width:6px;
		height:6px;
		border-radius:50%;
		margin-right:10px;
	}
	.point-box{
		display :flex;
		align-items:center;
		justify-content :center
	}
	.valet-foot{
		height :40px;
		display :flex;
		align-items center;
		justify-content :center
	}
}

</style>
<style lang="stylus">
.gift-body {
	.radioClass {
		.el-radio__label{
			display:none
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}
	.cell{
		padding :0px !important
	}
}
.el-picker-panel__footer{
		.el-picker-panel__link-btn.el-button--text  {
			display: none;
		}
	}
</style>
